import { createContext, useMemo } from "react";
import { useSyncedRef } from "../../../misc/SyncedRef";
import { jsx as _jsx } from "react/jsx-runtime";
export const Task2CardContext = /*#__PURE__*/ createContext({ reload: () => { } });
export function Task2CardProvider(props) { const reloadRef = useSyncedRef(props.onReload); const ctx = useMemo(() => ({ reload: () => reloadRef.current() }), [reloadRef]); return /*#__PURE__*/ _jsx(Task2CardContext.Provider, { value: ctx, children: props.children }); }
